// extracted by mini-css-extract-plugin
export default {"container":"empty-burger-message_container__kRgkp","logo":"empty-burger-message_logo__hX4kn","message":"empty-burger-message_message__eXFfa"};